export default __webpack_public_path__ + "static/media/wallet_connect.66f98648.svg";